(() => {
  const configNode = document.querySelector('[data-live-preview-config]');
  const dialog = document.querySelector('[data-live-preview-dialog]');
  const form = document.querySelector('.personalization-form');
  const openButton = form && form.querySelector('[data-live-preview-open]');
  if (!configNode || !dialog || !form || !openButton) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  const api = String(config.api || '').trim().replace(/\/+$/, '');
  const validApi = /^https:\/\/[^/]+/.test(api) || /^http:\/\/(127\.0\.0\.1|localhost)(:\d+)?$/.test(api);
  if (!validApi || typeof dialog.showModal !== 'function') {
    openButton.closest('.personal-actions').classList.remove('has-preview');
    openButton.remove();
    return;
  }
  const text = config.messages || {};
  // The page language picks the book's language (Turkish or English edition) and the name rules.
  const lang = config.lang === 'en' ? 'en' : 'tr';
  const nameInput = form.querySelector('[data-child-name]');
  const photoInput = form.querySelector('[data-child-photo]');
  // İsteğe bağlı anne / baba fotoğrafları (yalnızca ebeveyni olan kitaplarda).
  const parentInputs = [...form.querySelectorAll('[data-parent-photo]')];
  const linkInput = form.querySelector('[data-live-preview-id]');
  const submitButton = form.querySelector('button[type="submit"]');
  const statusText = dialog.querySelector('[data-live-preview-status]');
  const tipText = dialog.querySelector('[data-live-preview-tip]');
  const addButton = dialog.querySelector('[data-live-preview-add]');
  const figures = [...dialog.querySelectorAll('[data-live-preview-part]')];
  const storageKey = 'mupiko-live-preview:v1';
  const slowAfter = 150 * 1000;
  let active = null;
  let creating = false;
  let pollToken = 0;
  let pollTimer = 0;
  let tipTimer = 0;

  // The same child, photos and book reuse one preview instead of creating a new paid one.
  const fileKey = input => {
    const file = input.files && input.files[0];
    return file ? [file.name, file.size, file.lastModified].join(':') : '';
  };
  const signature = () => [config.handle, lang, nameInput.value.trim().normalize('NFC'), fileKey(photoInput),
    ...parentInputs.map(fileKey)].join('|');
  const store = {
    all() { try { return JSON.parse(sessionStorage.getItem(storageKey)) || {}; } catch { return {}; } },
    get(key) {
      const entry = this.all()[key];
      return entry && Date.now() - entry.at < 12 * 3600 * 1000 ? entry.id : null;
    },
    put(key, id) {
      try {
        const all = this.all();
        all[key] = { id, at: Date.now() };
        sessionStorage.setItem(storageKey, JSON.stringify(all));
      } catch { /* Gizli sekmede kayıt tutulamayabilir. */ }
    },
    drop(key) {
      try {
        const all = this.all();
        delete all[key];
        sessionStorage.setItem(storageKey, JSON.stringify(all));
      } catch { /* yok say */ }
    },
  };

  // A hidden line-item property links the order to the preview while the inputs still match it.
  const syncLink = () => {
    if (!linkInput) return;
    const linked = Boolean(active && active.signature === signature());
    linkInput.disabled = !linked;
    linkInput.value = linked ? active.id : '';
  };
  nameInput.addEventListener('input', syncLink);
  photoInput.addEventListener('change', syncLink);
  parentInputs.forEach(input => input.addEventListener('change', syncLink));

  // Show the name the way the book prints it: berat → Berat, ayşe gül → Ayşe Gül (Turkish i/ı rules).
  // English books (english_names.py): emma → Emma, MARY-JANE → Mary-Jane, McKenzie stays; Turkish letters keep Turkish rules.
  const turkishWord = word => {
    const [first, ...rest] = [...word];
    const lower = rest.join('').replaceAll('I', 'ı').replaceAll('İ', 'i').toLowerCase();
    return first.replaceAll('i', 'İ').replaceAll('ı', 'I').toUpperCase() + lower;
  };
  const englishWord = word => {
    const [first, ...rest] = [...word];
    const tail = rest.join('');
    return first.toUpperCase() + (word === word.toLowerCase() || word === word.toUpperCase() ? tail.toLowerCase() : tail);
  };
  const titleCase = value => {
    const turkish = lang === 'tr' || /[çğıöşüÇĞİÖŞÜ]/.test(value);
    return value.replace(/[^\s-]+/gu, turkish ? turkishWord : englishWord);
  };
  const tidyName = () => {
    const fixed = titleCase(nameInput.value.trim());
    if (fixed === nameInput.value) return;
    nameInput.value = fixed;
    nameInput.dispatchEvent(new Event('input', { bubbles: true }));
  };
  nameInput.addEventListener('change', tidyName);

  const setStatus = (state, message) => {
    dialog.dataset.state = state;
    statusText.textContent = message || '';
    if (state !== 'uploading' && state !== 'generating' && state !== 'slow') stopTips();
  };
  const stopTips = () => {
    clearInterval(tipTimer);
    tipTimer = 0;
    tipText.textContent = '';
  };
  const startTips = () => {
    const tips = (text.tips || []).filter(Boolean);
    if (tipTimer || !tips.length) return;
    let index = 0;
    tipText.textContent = tips[0];
    tipTimer = setInterval(() => {
      index = (index + 1) % tips.length;
      tipText.textContent = tips[index];
    }, 6500);
  };
  const resetFigures = () => figures.forEach(figure => {
    figure.dataset.status = 'queued';
    const image = figure.querySelector('img');
    image.hidden = true;
    image.removeAttribute('src');
    delete image.dataset.src;
  });
  const showParts = parts => parts.forEach(part => {
    const figure = figures.find(item => item.dataset.livePreviewPart === part.key);
    if (!figure) return;
    const image = figure.querySelector('img');
    if (part.status !== 'completed' || !part.url) {
      figure.dataset.status = part.status;
      return;
    }
    if (image.dataset.src === part.url) return;
    image.dataset.src = part.url;
    figure.dataset.status = 'loading';
    image.onload = () => { image.hidden = false; figure.dataset.status = 'completed'; };
    image.onerror = () => { figure.dataset.status = 'failed'; };
    image.src = part.url;
  });
  const render = (data, startedAt) => {
    const parts = Array.isArray(data.parts) ? data.parts : [];
    showParts(parts);
    const ready = parts.filter(part => part.status === 'completed').length;
    if (data.status === 'completed') setStatus('completed', text.ready);
    else if (data.status === 'partial') setStatus('partial', text.partial);
    else if (data.status === 'failed') setStatus('failed', text.failed);
    else if (Date.now() - startedAt > slowAfter) setStatus('slow', text.slow);
    else {
      setStatus('generating', ready ? text.almost : text.generating);
      startTips();
    }
  };

  const stopPolling = () => {
    pollToken += 1;
    clearTimeout(pollTimer);
  };
  const poll = () => {
    stopPolling();
    const token = pollToken;
    const startedAt = active.startedAt || Date.now();
    let errors = 0;
    const tick = async () => {
      if (token !== pollToken || !active) return;
      try {
        const response = await fetch(`${api}/api/previews/${encodeURIComponent(active.id)}`, { cache: 'no-store' });
        if (response.status === 404) {
          store.drop(active.signature);
          throw Object.assign(new Error('missing'), { fatal: true });
        }
        const data = await response.json();
        if (!response.ok) throw new Error(data.message || 'error');
        if (token !== pollToken) return;
        errors = 0;
        render(data, startedAt);
        if (data.status !== 'generating') return;
      } catch (error) {
        if (token !== pollToken) return;
        errors += 1;
        if (error.fatal || errors >= 5) {
          setStatus('failed', text.failed);
          return;
        }
      }
      pollTimer = setTimeout(tick, errors ? 5000 : 3000);
    };
    tick();
  };

  // Small JPEG keeps mobile uploads fast; the original photo still goes to the order untouched.
  // A background tab may pause decoding, so after a few seconds the original photo is sent instead.
  const within = (promise, ms) => Promise.race([promise, new Promise(resolve => setTimeout(() => resolve(null), ms))]);
  const shrink = async file => {
    const url = URL.createObjectURL(file);
    try {
      const image = new Image();
      image.src = url;
      if (await within(image.decode().then(() => true), 4000) !== true) return file;
      const scale = Math.min(1, 1536 / Math.max(image.naturalWidth, image.naturalHeight));
      const canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
      canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
      const context = canvas.getContext('2d');
      context.fillStyle = '#fff';
      context.fillRect(0, 0, canvas.width, canvas.height);
      context.drawImage(image, 0, 0, canvas.width, canvas.height);
      const blob = await within(new Promise(resolve => canvas.toBlob(resolve, 'image/jpeg', 0.9)), 4000);
      return blob && blob.size ? blob : file;
    } catch {
      return file;
    } finally {
      URL.revokeObjectURL(url);
    }
  };

  const create = async key => {
    setStatus('uploading', text.uploading);
    startTips();
    const body = new FormData();
    body.append('handle', config.handle);
    body.append('lang', lang);
    body.append('name', nameInput.value.trim());
    body.append('consent', '1');
    body.append('photo', await shrink(photoInput.files[0]), 'cocuk.jpg');
    for (const input of parentInputs) {
      const role = input.dataset.parentPhoto;
      if (input.files && input.files[0]) body.append(role, await shrink(input.files[0]), `${role}.jpg`);
    }
    const response = await fetch(`${api}/api/previews`, { method: 'POST', body });
    let data = {};
    try { data = await response.json(); } catch { /* boş yanıt */ }
    if (!response.ok || !data.id) throw Object.assign(new Error('preview'), { friendly: data.message });
    store.put(key, data.id);
    return data;
  };

  openButton.addEventListener('click', async () => {
    // Same checks as "Sepete ekle": name, a valid photo and the photo consent.
    tidyName();
    nameInput.dispatchEvent(new Event('input', { bubbles: true }));
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }
    const key = signature();
    const same = Boolean(active && active.signature === key);
    stopPolling();
    if (!same) {
      active = null;
      resetFigures();
    }
    addButton.disabled = Boolean(submitButton && submitButton.disabled);
    dialog.showModal();
    const savedId = active ? null : store.get(key);
    if (active || savedId) {
      if (!active) active = { id: savedId, signature: key };
      syncLink();
      if (!same || dialog.dataset.state !== 'completed') {
        setStatus('generating', text.generating);
        startTips();
      }
      poll();
      return;
    }
    if (creating) return;
    creating = true;
    openButton.disabled = true;
    try {
      const data = await create(key);
      active = { id: data.id, signature: key, startedAt: Date.now() };
      syncLink();
      render(data, active.startedAt);
      if (dialog.open && data.status === 'generating') poll();
    } catch (error) {
      // The service writes its messages in Turkish; other languages get the page's own text.
      const friendly = lang === 'tr' ? error.friendly : '';
      setStatus('failed', friendly || (navigator.onLine === false ? text.offline : text.failed));
    } finally {
      creating = false;
      openButton.disabled = false;
    }
  });

  // Either "Sepete ekle" (in the form or in the preview) counts as adding a previewed book to the cart.
  form.addEventListener('submit', event => {
    if (!event.defaultPrevented) tidyName();
    syncLink();
    if (event.defaultPrevented || !active || active.signature !== signature()) return;
    fetch(`${api}/api/previews/${encodeURIComponent(active.id)}/cart`, { method: 'POST', keepalive: true }).catch(() => {});
  });
  addButton.addEventListener('click', () => {
    dialog.close();
    if (typeof form.requestSubmit === 'function') form.requestSubmit(submitButton || undefined);
    else if (submitButton) submitButton.click();
  });
  dialog.querySelectorAll('[data-live-preview-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  dialog.addEventListener('close', () => {
    stopPolling();
    stopTips();
  });
})();
